module.exports = __webpack_public_path__ + "img/showadz-icon.b4a9eb55.svg";